module.exports = __webpack_public_path__ + "static/media/16-14.9d0b49ca.mp3";